// @flow
import * as React from 'react';
import { withTheme } from 'styled-components';
import { translate } from 'react-i18next';
import { Container } from 'statsradio/themes/v3/Stylesheet';
import { type Period } from '../../../domain/DashboardData';
import MetricCard from './DashboardMetricCard';

export const CUMULATIVE_REACH_ID = 'cumulative-reach-card';
export const CUMULATIVE_LISTENING_TIME_ID = 'cumulative-listening-time-card';
export const REACH_ID = 'reach-card';
export const LISTENING_TIME_ID = 'listening-time-card';

interface Props {
  period: Period;
  metrics: Object;
  t: (key: string) => string;
  theme: Object;
}

export function DashboardMetricsHeader({ period, metrics, t, theme }: Props) {
  const averageMetricsLabel = {
    reach: period === 'weekly' ? 'reach' : 'weeklyReach',
    listeningTime: period === 'weekly' ? 'listeningTime' : 'weeklyListeningTime',
  };

  const Reach = ({ label, value }) => (
    <MetricCard
      color={theme.V3.colors.reach}
      label={label}
      suffix={t('personsSymbol')}
      value={value}
    />
  );

  const ListeningTime = ({ label, value }) => (
    <MetricCard
      color={theme.V3.colors.listeningTime}
      label={label}
      suffix={t('time.hoursSymbol')}
      value={value}
    />
  );

  return (
    <React.Fragment>
      { period === 'monthly' &&
        <Container>
          <Reach
            id={CUMULATIVE_REACH_ID}
            label={t('cumulativeReach')}
            value={metrics.cumulativeReach}
          />
          <ListeningTime
            id={CUMULATIVE_LISTENING_TIME_ID}
            label={t('cumulativeListeningTime')}
            value={metrics.cumulativeListeningTime}
          />
        </Container>
      }
      <Container>
        <Reach
          id={REACH_ID}
          label={t(averageMetricsLabel.reach)}
          value={metrics.averageReach}
        />
        <ListeningTime
          id={LISTENING_TIME_ID}
          label={t(averageMetricsLabel.listeningTime)}
          value={metrics.averageListeningTime}
        />
      </Container>
    </React.Fragment>
  );
}

export default translate('dashboard', 'metrics')(withTheme(DashboardMetricsHeader));




// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/v2/components/metrics/DashboardMetricsHeader.js